
import styled from 'styled-components';
import Typography from '../../../../../components/typography/Typography';
import TextRow, { RowBase, RowLabel, RowValue } from '../../components/TextRow';
import BasicPopover from '../../../../../components/popover/Popover';
import Person from '../../../../../components/person/Person';
import ContactCard from '../../../../../components/contact-card/ContactCard';
import {BookingState} from "../../../../../api/api";
import {
    formatDateHourString,
    getFullDateString
} from "../../../../../utils/dateHandling";
import {BookingStateBadge} from "../../../workplan-view/day-overview/day-overview-booking/BookingStateBadge";

export interface BookingProps {
  index: number;
  assignedTechnicianName?: string;
  assignedTechnicianEmail?: string;
  isAppointmentFixed?: boolean
  plannedArrival?: string;
  appointmentFrom?: string;
  appointmentTo?: string;
  bookingState?: BookingState;
}

export const BookingDetailsOnTask = (props: BookingProps) => {
  const {
    index,
    assignedTechnicianName,
    assignedTechnicianEmail,
    isAppointmentFixed,  
    plannedArrival,
    appointmentFrom,
    appointmentTo,
      bookingState
  } = props;

  return (
    <StyledRowBase level={index}>
      <StyledRowValue>
        {assignedTechnicianEmail ? (
          <BasicPopover
            buttonElement={<Person name={assignedTechnicianName ?? 'Ukendt'} />}
            popoverElement={<ContactCard email={assignedTechnicianEmail} />}
          />
        ) : (
          <Typography fontStyle="italic">Ingen tekniker</Typography>
        )}
      </StyledRowValue>
        
        <StyledRowValue>{plannedArrival ? getFullDateString(new Date(plannedArrival)) : '-'}</StyledRowValue>

      <StyledRowValue>
          {appointmentFrom && appointmentTo
              ? `${formatDateHourString(appointmentFrom)} - ${formatDateHourString(
                  appointmentTo
              )}` : ''}
      </StyledRowValue>

      <StyledRowValue>
          <BookingStateBadge state={bookingState} isFixedAppointment={isAppointmentFixed} />
      </StyledRowValue>
    </StyledRowBase>
  );
};

const StyledRowBase = styled(RowBase)<{ level: number }>`
  align-items: center;
`;

const StyledRowValue = styled(RowValue)`
  display: flex;
  align-items: center;
`;

const StyledSpacing = styled(Typography)`
  margin-right: 5px;
`;

const StatusTagContainer = styled.div`
  flex: 3;
`;

const StyledRowLabel = styled(RowLabel)`
  overflow-wrap: anywhere;
`;
